const doc = [({"en":({"firstLineType":"First LINE type", "continentsOrCruise":"Continents or cruise"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;